import {Injectable} from '@angular/core';
import {DialogConfigProviderService} from './dialog-config-provider.service';
import {BotResult} from 'botato-botengine-browser/botato/botato-botengine/source/Core/BotResult/BotResult.js';
import {NlpInterpretation} from 'botato-botengine-browser/botato/botato-botengine/source/Core/Nlp/NlpInterpretation.js';

@Injectable()
export abstract class BotatoChatLocalHandlerService {

    constructor(public dialogConfigProvider: DialogConfigProviderService) {
    }

    public abstract handle(interpretation: NlpInterpretation): Promise<BotResult>;
}

